import { BasicSelect, MultiSelect } from 'vue-search-select';
import CryptoJS from 'crypto-js';
import Pagination from './../../../shared/components/pagination';
import CustomExpandableTable from '../../../shared/components/customExpandableTable';
import Loader from '../../../shared/components/loader';
import CONSTANT from './../../../shared/constants/constant';
import Util from './../../../shared/util/util';
import Treeselect from '@riophae/vue-treeselect';
// import FTCMemoDepositSlip from './../FTCMemoDepositSlip';
import Printd from 'printd'
import TripServices from '../../services/firstAndLastmilemanagement.service'

import XLSX from 'xlsx';
const moment = require('moment');

export default {
  name: 'createFTCRADShipment',
  components: {
    Treeselect,
    CryptoJS,
    Pagination,
    BasicSelect,
    CustomExpandableTable,
    Loader,

  },
  props: ['parentObj'],
  data: function () {
    return {
      showPrintCashMemo: false,
      createFtcRadShipment: false,
      expanded: false,
      isLoading: false,
      ftctotalamtwogst:'',
      accordianTab: { 1: false, 2: false, 3: false ,4:false,5:false},
      showFTCAmount: false,
      AWB: "",
      NoofMPS: "",
      origincity:'',
      destinationcity:'',
      gst:'',
      isawbvalid:1,
      pickupdate:'',
      raddate:'',
      consignoraddress1: '',
      consignoraddress2: '',
      consigneeaddress1 : '',
      consigneeaddress2 : '',
      pickuppincode : '',
      destinationpincode:'',
      paymentlink:'',
      pickupstate:'',
      destinationstate:'',
      freightChargesData:{},
      insurancechargesData:{},
      accessorialchargesData:{},
      awbExtraChargesData:{},
      totalFTCamount: '',
      totalaccessorialCharges: '',
      totalawbextracharges: '',
      totalfreightcharges: '',
      totalinsurancecharges: '',
      showCharges:false,
      amountBeforeTdsDeduction: null,
      isTDSApplcable: null,
      tdspopup : true
    }
  },
  computed: {

  },
  mounted() {
    this.paymentid = this.$route.params.id
    localStorage.removeItem('tableItems');
    localStorage.removeItem('_grecaptcha');
    this.getFTCpaymentBreakup()
  },
  methods: {

    async getFTCpaymentBreakup(){
      try {
        this.isLoading = true;
        let payload = {
          id : this.paymentid
        }
        let data = await TripServices.GetFTCpaymentbreakup(payload);
        if(data.data.code == 200){
          let details = data.data.data.data.awbRADdetails.data;
          let paymentbreakup = data.data.data.data.finalResponseObject
          this.AWB = details.AWB
          this.NoofMPS = details["MPS Count"]
          this.origincity = details.pickupCity
          this.destinationcity = details.dropCity
          this.pickupdate = moment(details.PickUpDate).tz('Asia/Kolkata').format('DD/MM/YYYY')
          this.raddate = details.RAADDate ? moment(details.RAADDate).tz('Asia/Kolkata').format('DD/MM/YYYY') : null
          this.consignoraddress1 = details.ConsignorName
          this.consignoraddress2 = details.ConsignorAddress
          this.consigneeaddress1 = details.ConsigneeName
          this.consigneeaddress2 = details.ConsigneeAddress
          this.pickuppincode = details.pickupPincode
          this.destinationpincode = details.dropPincode
          this.pickupstate = details.pickupState
          this.destinationstate = details.dropState
          this.freightChargesData = paymentbreakup.freightCharges;
          this.insurancechargesData = paymentbreakup.insurancecharge;
          this.accessorialchargesData = paymentbreakup.accessorialCharges;
          this.awbExtraChargesData = paymentbreakup.awbextracharges;
          this.totalFTCamount = paymentbreakup.totalFTCamount;
          this.ftctotalamtwogst = paymentbreakup.ftctotalamtwogst;
          this.gst = paymentbreakup.gst
          this.totalaccessorialCharges = paymentbreakup.totalaccessorialCharges;
          this.totalawbextracharges = paymentbreakup.totalawbextracharges;
          this.totalfreightcharges = paymentbreakup.totalfreightcharges;
          this.totalinsurancecharges = paymentbreakup.totalinsurancecharges;
          this.paymentlink = paymentbreakup.paymentlink;
          this.amountBeforeTdsDeduction = paymentbreakup.amountBeforeTdsDeduction
          this.isTDSApplcable = paymentbreakup.isTDSApplcable
          if (paymentbreakup.isTDSApplcable == 1) {
            this.tdspopup = false;
          }
          this.showCharges = true;
          this.isLoading = false;
        }else if(data.data.code == 409){
          this.isawbvalid = 0;
          this.isLoading = false;
        }
        else{
          this.isLoading = false;
          this.$router.push('/pages')
         // this.$alert(null, data.data.message, "error");
        }
      } catch (err) {
        this.isLoading = false;
        this.$router.push('/pages')
      }
    },
    openPaymentLink(){
      if (this.tdspopup) {
        this.checkTAN()
      }else{
        window.location = this.paymentlink;
      }
    },
    expandAll() {
      this.expanded = true;
      for (var key in this.accordianTab) {
        this.accordianTab[key] = true;
      }
    },
    collapseAll() {
      this.expanded = false;
      for (var key in this.accordianTab) {
        this.accordianTab[key] = false;
      }
    },
    toggleCheck(tabid) {
      this.expanded = false;
      for (var key in this.accordianTab) {
        if (tabid != key) {
          this.accordianTab[key] = false;
        }
      }
    },
    isTANApplicable() {
      return this.$fire({
        title: 'Is TDS applicable?',
        html:`<p>Please confirm if tds is applicable for this shipment ${this.AWB}</p>`,
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.dismiss == 'cancel') {
          this.tdspopup = false
        }
        return result.value;
      });
    },
    askAndSubmitTAN() {
      return this.$fire({
        title: ' ',
        html : `<p>Please confirm if tds is applicable for this shipment ${this.AWB}</p>
                <label for="tanInput">Enter TAN:</label>`,
        input: 'text',
        inputAttributes: {
          autocapitalize: 'off',
          placeholder: 'AAAA99999A'
        },
        showCancelButton: true,
        confirmButtonText: 'Submit',
        showLoaderOnConfirm: true,
        preConfirm: async (tan) => {
          if (this.validateTAN(tan)) {
            let submitTdsResponse = await this.submitTAN(tan);
            if (submitTdsResponse.data.code == 200) {
              return this.$alert('TAN is valid and has been submitted.', 'Success', 'success').then(async (result) => {
                if (result == true) {            
                 window.location.href = "/#/makeftcpayment/"+ submitTdsResponse.data.data.id ;
                 window.location.reload();
                }
               });
            }else{
             return this.$alert(submitTdsResponse.data.message , 'Error', 'error');
            }
          } else {
            return this.$alert('Invalid TAN. Please try again.', 'Error', 'error');
          }
        },
        allowOutsideClick: () => !this.$fire.isLoading()
      });
    },
    validateTAN(tan) {
      const tanRegex = /^[A-Z]{4}[0-9]{5}[A-Z]{1}$/;
      return tanRegex.test(tan);
    },
    async submitTAN(tan) {
      try {
        this.isLoading = true;
          let payload = {
            awb : this.AWB,
            istdsapplicable : 1,
            tan : tan,
            paymentmode : 2
          }
          let data = await TripServices.savetdsdetailspaymentlink(payload);
        
          this.isLoading = false
          console.log(`TAN ${tan} submitted successfully!`);
          return data;
      } catch (error) {
        this.isLoading = false;
        console.log(error); 
      }
    },
    async checkTAN() {
      const isApplicable = await this.isTANApplicable();
      if (isApplicable) {
        this.askAndSubmitTAN();
      } else {
        this.$alert('TDS is not applicable.', 'Info', 'info');
      }
    },

  }
}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/makeFTCPayment/makeFTCPayment.component.js